module.exports = __webpack_public_path__ + "img/jpg-dianpu@2x.bcfc90ec.png";